import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import {withStyles} from '@mui/styles';
import Grid from '@mui/material/Grid';
import DataGrid from '../../components/datagrid/DataGrid';

const styles = theme => ({
  root: {
    padding: 10
  },
  leftIcon: {
    marginRight: theme.spacing(2)
  }
});

const dataFeeTypes = [
  { id: 1, name: 'Ad Verification - Data Logix' },
  { id: 2, name: 'Ad Verification - Double Verify' },
  { id: 3, name: 'Ad Verification - InsightExpress' },
  { id: 4, name: 'Ad Verification - Integral Ad Science' },
  { id: 5, name: 'Rich Media - Jivox' },
  { id: 6, name: 'Rich Media - Sizmek' },
  { id: 7, name: 'Viewability - Integral Ad Science' }
];

const columns = [
  { id: 'name',
    label: 'Fee Type',
    select: dataFeeTypes.map(dft => dft.name),
    editable: 'always'
  },
  { id: 'amount',
    label: 'Amount',
    editable: 'always',
    numeric: true
  }
];


class DataFees extends Component {

  onAdd = () => {
    const { dataFees } = this.props;
    const dataFees1 = dataFees.slice(0);
    dataFees1.push({ name: '', amount: 0 });
    dataFees1.sort((a, b) => {
      if (a.name > b.name) return 1;
      if (a.name < b.name) return -1;
      return 0
    });
    const evt = {
      target: { name: 'DataFees', value: dataFees1 }
    };
    this.props.onChange(evt);
  };

  /**
   * If we are doing the name, avoid duplicates and include the dataFeeType object
   * @param row
   * @param name
   * @param value
   */
  onCellEdit = (row, name, value) => {
    const { dataFees } = this.props;
    const dataFees1 = dataFees.slice(0);
    if (name === 'name' && dataFees1.find(df => df.name === value)) {
      row = { name: '', amount: 0, id: undefined };
      return;
    }
    const index = dataFees1.findIndex(d => (d.DataFeeType || {}).name === row.name);
    dataFees1[index][name] = value;
    if (name === 'name') {
      const thisFeeType = dataFeeTypes.find(dft => dft.name === value);
      dataFees1[index].DataFeeType = {
        id: thisFeeType.id,
        name: value
      }
    }
    const evt = {
      target: { name: 'DataFees', value: dataFees1 }
    };
    this.props.onChange(evt);
  };

  onDelete = deleted => {
    const { dataFees } = this.props;
    const ids = deleted.map(d => d.name);
    const dataFees1 = dataFees.filter(d => ids.indexOf(d.name) === -1);
    const evt = {
      target: { name: 'DataFees', value: dataFees1 }
    };
    this.props.onChange(evt);
  };

  getRows = (dataFees) => {
    if (isEmpty(dataFees)) {
      return [];
    }
    return dataFees.map(df => Object.assign({}, df, {
      name: (df.DataFeeType || {}).name,
      amount: df.amount,
      id: df.id
    }));
  };

  render() {
    const { classes, dataFees } = this.props;

    return (
      <div className={classes.root}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <DataGrid
              columns={columns}
              data={this.getRows(dataFees)}
              title="Third-Party Fees"
              onAdd={this.onAdd}
              onCellEdit={this.onCellEdit}
              onDelete={this.onDelete}
              suppressCount
              plain
              selectable
              showFilterRow
            />
          </Grid>
        </Grid>
      </div>
    )
  }
}

DataFees.defaultProps = {
  dataFees: []
};

DataFees.propTypes = {
  dataFees: PropTypes.array,
  onChange: PropTypes.func.isRequired
};

export default withStyles(styles)(DataFees);
